export default "__VITE_ASSET__BfxsESNw__"